import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginContainer from "../components/atomic/molecular/LoginContainer";

import Email from "../components/atomic/ui/input/Email";
import Password from "../components/atomic/ui/input/Password";
import SubmitButton from "../components/login/SubmitButton";
import ForgotPasswordButton from "../components/atomic/molecular/ForgotPasswordButton";
import DividerSnsLabel from "../components/atomic/ui/DividerSnsLabel";
import GoogleButton from "../components/atomic/ui/GoogleButton";
import InitGoogleLoginButton from "../components/atomic/ui/InitGoogleLoginButton";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmailIcon from "@mui/icons-material/Email";

function Login() {
  const navigate = useNavigate();
  const [isSignedIn, setIsSignedIn] = useState(false);

  const navigateMypage = () => {
    navigate("/mypage/accounts");
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    try {
      if (email === "" || password === "") {
        alert("メールアドレスとパスワードを入力してください");
        return null;
      }
      setIsSignedIn(true);
      await Auth.signIn(email, password);
      setIsSignedIn(false);
      navigateMypage();
    } catch (e) {
      console.log(e);
      if (e.code === "NotAuthorizedException") {
        alert("メールアドレスまたはパスワードが間違っています");
      }
      if (e.code === "UserNotFoundException") {
        alert("メールアドレスまたはパスワードが間違っています");
      }
      if (e.code === "UserNotConfirmedException") {
        alert("メールアドレスの確認が完了していません");
        localStorage.setItem("signUpEmail", email);
        navigate("/signup/conform");
      }
      setIsSignedIn(false);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await Auth.federatedSignIn({ provider: "Google" });
      navigate("/wait");
    } catch (e) {
      console.log(e);
    }
  };

  const handleSignInStatus = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (!!user) {
        navigateMypage();
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    handleSignInStatus();
  }, []);

  return (
    <LoginContainer label={"ナッシュアンバサダープログラムログイン"}>
      <Box sx={{ marginTop: "32px" }}>
        <GoogleButton onClick={handleGoogleSignIn} />
      </Box>

      <Box sx={{ marginTop: "32px" }}>
        <form onSubmit={handleSignIn}>
          <Accordion
            sx={{
              border: "1px solid rgba(222, 229, 238, 1)",
              boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",
            }}
          >
            <AccordionSummary aria-controls="panel1a-content" id="panelHead">
              <EmailIcon
                sx={{
                  color: "primary.main",
                  marginRight: "8px",
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  メールアドレスでログイン
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <>
                <Email />
                <Password />
                <SubmitButton buttonLabel={"ログイン"} isLoading={isSignedIn} />
              </>
              <ForgotPasswordButton />
            </AccordionDetails>
          </Accordion>
        </form>
      </Box>

      <InitGoogleLoginButton disabled />
    </LoginContainer>
  );
}

export default Login;
